import { rp, fmtDateTime, METHOD_LABEL } from "@/lib/api";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function printReceipt(bill, settings) {
  const s = settings || {};
  const t = bill.totals;
  const p = bill.payment || {};
  const rows = bill.items
    .map((i) => `<tr><td colspan="2">${esc(i.name)}</td></tr><tr><td>${i.qty} x ${rp(i.price)}</td><td class="r">${rp(i.qty * i.price)}</td></tr>`)
    .join("");
  const html = `<!doctype html><html><head><title>Struk ${esc(bill.code)}</title><style>
    @page{size:58mm auto;margin:3mm}body{font-family:'Courier New',monospace;font-size:11px;width:52mm;margin:0 auto;color:#000}
    h2{font-size:14px;text-align:center;margin:0}.c{text-align:center}.r{text-align:right}table{width:100%;border-collapse:collapse}
    hr{border:0;border-top:1px dashed #000;margin:6px 0}td{padding:1px 0;vertical-align:top}.b{font-weight:bold}
  </style></head><body>
  <h2>${esc(s.app_name || "GoMenu")}</h2>
  ${s.address ? `<div class="c">${esc(s.address)}</div>` : ""}${s.phone ? `<div class="c">${esc(s.phone)}</div>` : ""}
  <hr/><table><tr><td>No. Bill</td><td class="r">${esc(bill.code)}</td></tr>
  <tr><td>Meja</td><td class="r">${esc(bill.table_name)}</td></tr><tr><td>Pelanggan</td><td class="r">${esc(bill.customer_name)}</td></tr>
  <tr><td>Kasir</td><td class="r">${esc(bill.cashier_name || "-")}</td></tr><tr><td colspan="2">${fmtDateTime(bill.paid_at || bill.created_at)}</td></tr></table>
  <hr/><table>${rows}</table><hr/><table>
  <tr><td>Subtotal</td><td class="r">${rp(t.subtotal)}</td></tr>
  ${t.discount ? `<tr><td>Diskon ${esc(t.discount_label || "")}</td><td class="r">-${rp(t.discount)}</td></tr>` : ""}
  <tr><td>Service ${t.service_percent}%</td><td class="r">${rp(t.service)}</td></tr>
  <tr><td>Pajak ${t.tax_percent}%</td><td class="r">${rp(t.tax)}</td></tr>
  <tr class="b"><td>TOTAL</td><td class="r">${rp(t.total)}</td></tr>
  ${p.method ? `<tr><td>${esc(METHOD_LABEL[p.method])}</td><td class="r">${rp(p.amount_paid)}</td></tr><tr><td>Kembali</td><td class="r">${rp(p.change)}</td></tr>` : ""}
  </table><hr/><div class="c">${esc(s.receipt_footer || "Terima kasih!")}</div>
  <script>window.onload=function(){window.print();setTimeout(function(){window.close()},300)}</script></body></html>`;
  const w = window.open("", "_blank", "width=380,height=640");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
